import { useAuth } from "../hooks/auth";
import { Navigate, useLocation } from "react-router-dom";
import { getUserData } from "./utilities";

export const ProtectedEntry = ({ children }) => {
  const auth = useAuth();
  const user = getUserData();
  const location = useLocation();

  if (!auth?.user) {
    return <Navigate to="/login" state={{ path: location.pathname }} />;
  }

  if (user.role == "SuperAdmin") {
    return <Navigate to="/admin-users" replace />;
  } else {
    return <Navigate to="/employee-profiles/list" replace />;
  }
};
